import { ButtonOption } from 'src/app/model';

export enum ViewType {
  TILE_VIEW = 'tile-view',
  LIST_VIEW = 'list-view',
  TREE_VIEW = 'tree-view',
  GRAPH_VIEW = 'graph-view',
  TABLE_VIEW = 'table-view',
  NESTED_TREE_VIEW = 'nested-tree-view',
  EXPAND_VIEW = 'expand-view',
  COLLAPSE_VIEW = 'collapse-view',
  VIEW_ALL = 'view-all'
}

export enum ViewSwitcherColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TRANSPARENT = 'transparent'
}

export type ViewSwitcherColorType = ViewSwitcherColor.PRIMARY | ViewSwitcherColor.SECONDARY | ViewSwitcherColor.TRANSPARENT;

export interface ViewSwitcherOptionModel {
  tooltip: string;
  type?: ViewType;
  dynamicType?: string;
  icon?: string;
  iconUrl?: string;
  active?: boolean;
  color?: ViewSwitcherColorType;
}